export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'Home',
        route: 'dashboard',
        icon: 'HomeIcon',
      },
      {
        title: 'Customers',
        route: 'second-page',
        icon: 'UsersIcon',
      },
      {
        title: 'Transactions',
        route: 'second-page',
        icon: 'FileTextIcon',
      },
    ],
  },
]
